import React, { Component } from "react";
import { DKLabel, DKContactIcon, DKButton } from "deskera-ui-library";
import {
    COLUMN_CODE,
    PRODUCTS,
    TableManger,
    TABLES
} from "../../../managers/TableManger";
import Table from "../../../services/table";
import { getDashboardWidgetLoading } from "../../dashboard/Dashboard";
import { commonCustomEvent, COMMON_EVENTS } from "../../../services/event/commonEvents";
import ApiConstants from "../../../constants/ApiConstants";

interface IEleaveCardProps {
    product: string

}
interface IEleaveCardState {
    data: any[];
    showLoading: boolean;
}
class EleaveCard extends Component<IEleaveCardProps, IEleaveCardState> {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            showLoading: false
        }
    }
    componentDidMount() {

    }

    render() {
        return (
            <>
                <>
                    <div className="row">
                        {/* <DKButton
                            onClick={() => { window.open(ApiConstants.PRODUCT_URL_ELEAVE, "_blank") }}
                            title="Eleave"
                            className="bg-gray1 border-m"
                        /> */}
                    </div>
                    {!this.state.showLoading && this.state.data.length == 0 && this.getEmptyState()}
                </>
            </>

        )
    }
    getEmptyState = () => {
        return (
            <div
                className={`column parent-width parent-height align-items-center justify-content-center`}
            >
                <DKLabel text="No data found " className="fw-m fs-m text-gray" />
                {/* <DKLabel text="Add your first candidate" className="text-gray mt-xs" /> */}
            </div>
        );
    };
}

export default EleaveCard;